import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const menu = [
  { label: "Home", link: "/" },
  { label: "What We Do", link: "/what-we-do" },
  { label: "Insights", link: "/Insights" },
  // { label: "Our Network", link: "/our-network" },
  { label: "About", link: "/About" },
  { label: "Contact", link: "/contact-us" },
];

function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="fixed top-0 w-full z-[50] bg-white shadow-md">
      <div className="max-w-[1440px] mx-auto w-full lg:px-[70px] px-[20px] py-[6px] flex justify-between items-center">
        <Link to="/">
          <img src="/assets/logos/PNG.png" alt="Logo" className="lg:h-[94px] h-[60px]" />
        </Link>

        <div className="hidden lg:flex items-center gap-[30px]">
          {menu?.map((e, i) => (
            <Link
              key={i}
              to={e.link}
              className={`font-[500] font-neue text-[15px] leading-[27px] tracking-[0.5px] transition ${
                location.pathname === e.link
                  ? "text-[#BB872A]"
                  : "text-black hover:text-[#BB872A]"
              }`}
            >
              {e.label}
            </Link>
          ))}
        </div>

        {/* Menu Toggle */}
        <button
          className="lg:hidden text-black z-[60]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-[280px] bg-white shadow-lg transform transition-transform duration-500 lg:hidden z-[50] ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col items-start px-[20px] py-[10px] gap-4">
          {menu?.map((e, i) => (
            <Link
              key={i}
              to={e.link}
              onClick={() => setOpen(false)} 
              className={`font-[500] font-instrument text-[18px] leading-[27px] transition ${
                location.pathname === e.link
                  ? "text-[#BB872A]"
                  : "text-black hover:text-[#BB872A]"
              }`}
            >
              {e.label}
            </Link>
          ))}

          {/* <Link to="/contact-us" onClick={() => setOpen(false)}>
            <button
              style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
              className="mt-4 py-[12px] px-[15px] w-full transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-instrument text-[14px] leading-[20px] text-center text-[#FFFFFF]"
            >
              Contact Us
            </button>
          </Link> */}
        </div>
      </div>

      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 lg:hidden z-[40]"
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  );
}

export default Header;
